import './styles.scss'

import React, { useCallback, useEffect, useState } from 'react'

import { GameController } from '@Animation/game-control'
import { LoadingAnimation } from '@Components/loading/loading'

const CLASS_NAME = 'gby-k2g-animation'

export type AnimationCanvasProps = {
  isLoading: boolean
}

export const AnimationCanvas = React.memo((props: AnimationCanvasProps) => {
  const [gameContainerRef, setGameContainerRef] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!gameContainerRef) return

    GameController.setParentDiv(gameContainerRef)

    return () => {
      GameController.setParentDiv()
      GameController.stopDrawAnimation()
    }
  }, [gameContainerRef])

  const onRefSet = useCallback((node: HTMLDivElement) => {
    setGameContainerRef(node)
  }, [])

  const renderInnerElements = useCallback(() => {
    if (props.isLoading) {
      return (
        <div className={`${CLASS_NAME}__loading-container`}>
          {' '}
          <LoadingAnimation />{' '}
        </div>
      )
    }
  }, [props])

  return (
    <div className={`${CLASS_NAME}__game-window`} ref={onRefSet}>
      {renderInnerElements()}
    </div>
  )
})
